const columns = [
  {
    title: '',
    enTitle: 'Login Time',
    width: 130,
    dataIndex: 'loginTime',
    slot: 'date'
  },
  {
    title: '',
    enTitle: 'Terminal type',
    width: 120,
    dataIndex: 'terminalType'
  },
  {
    title: '',
    enTitle: 'Brower Version',
    width: 120,
    dataIndex: 'terminalVersion'
  },
  {
    title: '',
    enTitle: 'Operation System',
    width: 150,
    dataIndex: 'os'
  },
  {
    title: '',
    enTitle: 'Device',
    width: 80,
    dataIndex: 'terminalName'
  },
  {
    title: '',
    enTitle: 'IP Addess',
    width: 100,
    dataIndex: 'ip'
  },
  {
    title: '',
    enTitle: 'Addess',
    width: 200,
    dataIndex: 'address'
  }
]
import user from '@/api/user'
export default {
  data() {
    return {
      columns,
      dataSource: [],
      params: {},
      pagination: {
        total: 0,
        size: 10,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        showSizeChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: false
      }
    }
  },
  watch: {
    //监听相同路由下参数变化的时候，从而实现异步刷新
    $route: {
      handler() {
        this.id = this.$route.params.id
        this.getList()
      },
      immediate: true
    }
  },
  methods: {
    async getList(page = 1) {
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: this.pagination.size
      })
      const { list, pageIndex, pageSize, total } = await user.loginLog(
        this.id,
        data
      )
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
    }
  }
}
